module.exports = __webpack_public_path__ + "static/media/img01.2f998fde.png";